<template>
  <SkeletonBlock v-if="isMenuHidden" ref="skeletonBlock"></SkeletonBlock>
  <div v-else class="menu-top">
    <div class="menu-top__header-pc top-header-pc border-detail-top" :style="customValuesHeaderBackground">
      <img :src="customValues.logo" alt="escudo_golstats" class="logo-img" />
      <div class="top-header-pc__left-items"></div>
      <div class="top-header-pc__title" :style="customValuesHeaderColor">
        {{ category.name }}
      </div>
    </div>
    <div class="menu-top__header-pc top-header-pc" :style="customValuesHeader2Background">
      <div class="top-header-pc__left-items"></div>
      <div class="top-header-pc__right-items">
        <template v-if="category.id != 5">
          <BField>
            <span :class="{ active: !isTeam }">Individual</span>
            <BSwitch
              color="#000000"
              passive-type="is-success"
              type="is-success"
              size="is-small"
              v-model="isTeam"
            ></BSwitch>
            <span :class="{ active: isTeam }">Equipo</span>
          </BField>
        </template>
      </div>
      <div class="top-header-pc__left-items"></div>
    </div>
    <div class="menu-top__header top-header" :style="customValuesHeaderBackground">
      <img :src="customValues.logo" alt="escudo_golstats" class="logo-img" />
      <div class="top-header__left-items"></div>
      <div class="top-header__title" :style="customValuesHeaderColor">{{ category.name }}</div>

      <div class="top-header__right-items border-detail-bottom" :style="customValuesHeader2Background">
        <div class="top-header__right-items__background-cont">
          <template v-if="category.id != 5">
            <div class="container-filter-switch">
              <BField position="is-center">
                <span :class="{ active: !isTeam }">Individual</span>
                <BSwitch passive-type="is-success" type="is-success" size="is-small" v-model="isTeam"></BSwitch>
                <span :class="{ active: isTeam }">Equipo</span>
              </BField>
            </div>
          </template>
        </div>
      </div>
    </div>

    <YoureWatching
      :filters="arrayPredefinedFilters"
      :category="category.id"
      :selected="indexPredefinedFiltersSelected"
      :type="typeSelected"
      @changeCarousel="changeCarousel"
      @show="show"
    />
    <div class="container-menu-top-all">
      <div class="table-overlay-container" v-if="!isPremiumUser && bluer">
        <div class="table-overlay--desktop">
          <div class="div-centyer-text">
            <div>
              <span class="text-bold-overlay"><b>Solo para Usuarios Premium</b> </span><br />
              <span class="subtext-bold-overlay">Crea tu cuenta por $99 mxn al mes</span>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-top__body top-body" :class="{ blurred: !isPremiumUser && bluer }">
        <div class="top-body__table">
          <template v-if="statsData.data && topData.length > 0">
            <BCarousel
              :key="updateSlider"
              :autoplay="false"
              :pause-info="false"
              :arrow="false"
              :indicator-inside="false"
              @change="changeItem"
            >
              <BCarouselItem v-for="(carousel, i) in topData" :key="i">
                <section class="player-container">
                  <PlayerTable
                    :playerData="carousel"
                    :topValue="i"
                    :categories="category.categories"
                    :filters="filterSend"
                    :category="category.id"
                    :indexPage="i"
                    :viewImage="viewImage"
                    :season="season"
                    :customValues="customValues"
                    :is-team="isTeam"
                    :category-name="category.name"
                    :objectCategory="category"
                  />
                </section>
              </BCarouselItem>
            </BCarousel>
          </template>
          <template v-else>
            <template v-if="!filterActive">
              <template v-if="arePlaysEmpty">
                <div class="top-ptable__header" :style="`background-color: ${customValues.bgColor};`">
                  <span :style="`color: ${customValues.color}`">POS</span>
                  <span :style="`color: ${customValues.color}`">
                    <template v-if="!isTeam"
                      ><template v-if="tournamentSelected.id == 1001"
                        ><template v-if="category == 22">PORTERA</template
                        ><template v-else>JUGADORA</template></template
                      ><template v-else
                        ><template v-if="category == 22">PORTERO</template
                        ><template v-else>JUGADOR</template>z</template
                      ></template
                    >
                    <template v-else>EQUIPO</template>
                  </span>
                  <span :style="(`color: ${customValues.color}`, `text-align:left;`)">TOTAL</span>
                </div>
                <div class="container-not-found-data">
                  <div class="container-not-found-data__img-search">
                    <img src="https://golstatsimages.blob.core.windows.net/todoelfut/graf_busqueda@2x.png" width="74" />
                  </div>
                  <div class="container-not-found-data__title-info">Sin resultados</div>
                </div>
              </template>
              <template v-else>
                <div class="top-ptable__header" :style="`background-color: ${customValues.bgColor};`">
                  <span :style="`color: ${customValues.color}`">POS</span>
                  <span :style="`color: ${customValues.color}`">
                    <template v-if="!isTeam"
                      ><template v-if="tournamentSelected.id == 1001"
                        ><template v-if="category == 22">PORTERA</template
                        ><template v-else>JUGADORA</template></template
                      ><template v-else
                        ><template v-if="category == 22">PORTERO</template><template v-else>JUGADOR</template></template
                      ></template
                    >
                    <template v-else>EQUIPO</template>
                  </span>
                  <span :style="(`color: ${customValues.color}`, `text-align:left;`)">TOTAL</span>
                </div>
                <div v-for="index in 10" :key="index" class="placeholder-item" />
              </template>
            </template>
            <template v-if="filterActive">
              <div class="top-ptable__header" :style="`background-color: ${customValues.bgColor};`">
                <span :style="`color: ${customValues.color}`">POS</span>
                <span :style="`color: ${customValues.color}`">
                  <template v-if="!isTeam"
                    ><template v-if="tournamentSelected.id == 1001"
                      ><template v-if="category == 22">PORTERA</template><template v-else>JUGADORA</template></template
                    ><template v-else
                      ><template v-if="category == 22">PORTERO</template><template v-else>JUGADOR</template></template
                    ></template
                  >
                  <template v-else>EQUIPO</template>
                </span>
                <span :style="(`color: ${customValues.color}`, `text-align:left;`)">TOTAL</span>
              </div>
              <div class="container-not-found-data">
                <div class="container-not-found-data__img-search">
                  <img src="https://golstatsimages.blob.core.windows.net/todoelfut/graf_busqueda@2x.png" width="74" />
                </div>
                <div class="container-not-found-data__title-info">Sin resultados</div>
                <div class="container-not-found-data__subtitle-info">
                  No se encontraron resultados que<br />
                  coincidan con el filtrado.
                </div>
              </div>
            </template>
          </template>
        </div>
        <div class="top-body__filters">
          <FilterTable
            :key="2"
            :category="category.id"
            :customValues="customValues"
            :filtersPredefined="filtersPredefinedComputed"
            :type="typeSelected"
            :is-cup="isCup"
            :age-range="arrayAgeRange"
            :available-years="arrayAvailableYears"
            :nationality-ids="setNationalityIds"
            :position-ids="setPositionsIds"
            :available-national-teams="mapAvailableNationalTeams"
            :is-team="isTeam"
            :reset-values-counter="numberResetValuesCounter"
            @filters="filters"
          />
        </div>
      </div>
    </div>

    <div class="menu-top__drawer" :class="{ active: openLayer }">
      <div class="filter-drawer" :class="{ active: openDrawer }">
        <div class="close-button" @click="hideDrawer">
          <img
            src="https://golstatsimages.blob.core.windows.net/todoelfut/icn-close-white-no-cicrle.svg"
            @click="hideDrawer"
            alt="close"
            width="25"
          />
        </div>
        <FilterTable
          :key="1"
          :category="category.id"
          :customValues="customValues"
          :filtersPredefined="filtersPredefinedComputed"
          :type="typeSelected"
          :is-cup="isCup"
          :age-range="arrayAgeRange"
          :available-years="arrayAvailableYears"
          :nationality-ids="setNationalityIds"
          :position-ids="setPositionsIds"
          :available-national-teams="mapAvailableNationalTeams"
          :is-team="isTeam"
          :reset-values-counter="numberResetValuesCounter"
          @filters="filters"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import PlayerTable from '@/components/Sections/Top/PlayerTable';
import FilterTable from '@/components/Sections/Top/FilterTableV2';
import YoureWatching from '@/components/Sections/Top/YoureWatching';
import SkeletonBlock from '@/components/Sections/Top/SkeletonBlock';
import { mapGetters, mapState } from 'vuex';
import { BField } from 'buefy/dist/esm/field';
import { BSwitch } from 'buefy/dist/esm/switch';
import { BCarousel, BCarouselItem } from 'buefy/dist/esm/carousel';

export default {
  name: 'MenuV2',
  components: {
    PlayerTable,
    FilterTable,
    SkeletonBlock,
    BField,
    BSwitch,
    YoureWatching,
    BCarousel,
    BCarouselItem,
  },
  props: {
    logo: {
      type: String,
      default: '',
    },
    header: {
      type: Object,
      default: () => {},
    },
    bluer: {
      type: Boolean,
      default: true,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    header2: {
      type: Object,
      default: () => {},
    },
    interiors: {
      type: Object,
      default: () => {},
    },
    category: {
      type: Object,
      default: () => {},
    },
    season: {
      type: Number,
    },
    position: {
      type: Number,
      default: 1,
    },
    isPremiumUser: {
      type: Boolean,
      default: true,
    },
    isCup: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    objectSelectedFilters: {},
    arrayPredefinedFilters: [],
    arrayPredefinedOrigin: [],
    indexPredefinedFiltersSelected: 0,
    predefinedFiltersMatchLapse: [],
    predefinedFiltersPlayingAs: [],
    predefinedFiltersSections: [],
    system: '',
    url: 'https://8grl16o77j.execute-api.us-west-2.amazonaws.com/prod/topsBySeasonAndCategory',
    urlFilter: 'https://cqqxaonvm6.execute-api.us-east-2.amazonaws.com/prod/gs2/tops/filters?categories=',
    // urlFilter: 'https://081iciskwe.execute-api.us-east-2.amazonaws.com/qa/gs2/tops/filters?categories=',
    seasonID: 1401,
    statsData: {},
    zoneType: 1,
    updateCheck: 0,
    tab: 0,
    local: [1, 2],
    results: [1, 2, 3],
    firstTime: [1, 2, 3, 4, 5, 6],
    secondTime: [1, 2],
    zone: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
    viewImage: 0,
    typeSelected: 1,
    filterActive: false,
    topsTeams: {},
    topsPlayers: {},
    playersInfo: {},
    teamInfo: {},
    filtersSelect: {
      playingAs: [],
      matchResult: [],
      sections: [],
      zone: [],
      typeZone: [],
    },
    filterSend: [],
    updateSlider: 0,
    isTeam: false,
    formatStats: [],
    formatFilterStats: [],
    openLayer: false,
    openDrawer: false,
    customValues: {
      logo: '',
      bgColor: '#EDF4F9',
      color: '#fffff',
    },
    customValuesHeaderBackground: {
      background: '#dbefca',
    },
    customValuesHeader2Background: {
      background: '#3b3b3b',
      color: '#FFFFFF',
    },
    customValuesHeaderColor: {
      color: '#cbee6a',
    },
    data_headers: ['team_id', 'player_id', 'playing_as', 'match_result', 'section', 'total', 'origen', 'destino'],
    isMenuHidden: true,
    arePlaysEmpty: false,
    intersectionObserverCounter: 0,
    isVisible: false,
    playersImagesUrl: 'https://golstatsimages.blob.core.windows.net/players-profile/',
    tournamentSelected: { id: 1 },
    arrayAgeRange: [0, 0],
    arrayAvailableYears: [],
    setNationalityIds: new Set(),
    mapAvailableNationalTeams: new Map(),
    mapPlayers: new Map(),
    arrayCategoryIdsWithOutGoalkeeper: [2, 3, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 23],
    filterEmitAux: {},
    numberResetValuesCounter: 0,
  }),
  computed: {
    ...mapGetters('loginGeneral', ['getUser']),
    ...mapState('profileconfigGeneral', ['colorsConfig']),
    ...mapState({ windowWidth: 'windowWidth' }),
    setPositionsIds() {
      if (this.category.id === 22) {
        return new Set([1]);
      }
      if (this.arrayCategoryIdsWithOutGoalkeeper.includes(this.category.id)) {
        return new Set([2, 3, 4, 5, 6, 7, 8, 9]);
      }
      return new Set([1, 2, 3, 4, 5, 6, 7, 8, 9]);
    },
    filtersPredefinedComputed() {
      if (this.arrayPredefinedFilters.length > 0) {
        return this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined;
      } else {
        return {
          type: 1,
          sections: this.firstTime,
          matchResult: this.results,
          playingAs: this.local,
          zone: this.zone,
          typeZone: this.zoneType,
        };
      }
    },
    topData() {
      var topTeam = {};
      var topPlayer = {};
      var sortTopTeam = [];
      var sortTopPlayer = [];
      if (Object.entries(this.statsData).length > 0) {
        this.formatFilterStats.map(play => {
          if (topTeam[play.team_id]) {
            topTeam[play.team_id]['total'] = topTeam[play.team_id]['total'] + play.total;
          } else {
            topTeam[play.team_id] = {};
            topTeam[play.team_id]['total'] = play.total;
            topTeam[play.team_id]['id'] = this.teamInfo[play.team_id].id;
            topTeam[play.team_id]['name'] = this.teamInfo[play.team_id].name;
            topTeam[play.team_id]['img'] = 'https://golstatsimages.blob.core.windows.net/teams-80/' + play.team_id + '.png';
          }
          if (topPlayer[play.player_id]) {
            if (play.player_id != 0 && play.player_id != 62117) {
              topPlayer[play.player_id]['total'] = topPlayer[play.player_id]['total'] + play.total;
            }
          } else {
            if (play.player_id != 0 && play.player_id != 62117) {
              topPlayer[play.player_id] = {};
              topPlayer[play.player_id]['total'] = play.total;
              if (play.player_id && this.playersInfo[play.player_id]) {
                topPlayer[play.player_id]['name'] = this.playersInfo[play.player_id].name;
                topPlayer[play.player_id]['img'] = this.playersInfo[play.player_id].img;
                topPlayer[play.player_id]['id'] = this.playersInfo[play.player_id].id;
              } else {
                topPlayer[play.player_id]['id'] = '0';
                topPlayer[play.player_id]['name'] = '-';
                topPlayer[play.player_id]['img'] = 'SIN IMAGEN';
              }
            }
          }
        });
        for (const idTeam in topTeam) {
          sortTopTeam.push(topTeam[idTeam]);
        }
        for (const idPlayer in topPlayer) {
          sortTopPlayer.push(topPlayer[idPlayer]);
        }
        sortTopTeam.sort((a, b) => (a.total < b.total ? 1 : -1));
        sortTopPlayer.sort((a, b) => (a.total < b.total ? 1 : -1));
        sortTopTeam = sortTopTeam.slice(0, 60);
        sortTopPlayer = sortTopPlayer.slice(0, 60);
      }

      this.updateSliderF();
      if (this.isTeam) {
        return this.formatArrayPaginate(sortTopTeam);
      } else {
        return this.formatArrayPaginate(sortTopPlayer);
      }
    },
  },
  watch: {
    windowWidth: {
      immediate: true,
      handler() {
        if (this.arrayPredefinedFilters.length) {
          this.getTextFilterPredefinedCustom();
        }
      },
    },
    isTeam() {
      if (this.isTeam) {
        this.typeSelected = 0;
      } else {
        this.typeSelected = 1;
      }
      this.getTextFilterPredefinedCustom();
      this.viewImage = 0;
      this.updateSliderF();
    },
    logo: {
      immediate: true,
      handler: function(newValue) {
        this.customValues.logo = newValue;
      },
    },
    interiors: {
      immediate: true,
      handler: function(newValue) {
        this.customValues.bgColor = newValue.background;
        this.customValues.color = newValue.color;
      },
    },
    header: {
      immediate: true,
      handler: function(newValue) {
        this.customValuesHeaderBackground.background = newValue.background;
        this.customValuesHeaderBackground.color = newValue.color;
        this.customValuesHeaderBackground.borderColor = newValue.borderColor;
        this.customValuesHeader2Background.borderColor = newValue.borderColor;
      },
    },
    header2: {
      immediate: true,
      handler: function(newValue) {
        this.customValuesHeader2Background.background = newValue.background;
        this.customValuesHeader2Background.color = newValue.color;
      },
    },
    // isLoggedIn: {
    //   immediate: true,
    //   handler: async function(newValue) {
    //     if (newValue && !this.isMenuHidden) {
    //       await this.getCategoryStats(this.season);
    //       await this.getPredefinedfilters(this.category);
    //     }
    //   },
    // },
    season: {
      immediate: false,
      handler(newValue) {
        if (!newValue) return;
        const wasMenuHidden = this.isMenuHidden;
        this.topsTeams = {};
        this.topsPlayers = {};
        this.playersInfo = {};
        this.teamInfo = {};
        this.statsData = {};
        this.formatFilterStats = [];
        this.isMenuHidden = true;
        if (!wasMenuHidden) {
          this.intersectionObserverCounter = 0;
          this.isVisible = false;
          setTimeout(() => {
            this.setUpIntersectionObserver();
          }, 500);
        } else if (this.isVisible) {
          this.isMenuHidden = false;
        }
      },
    },
    async isMenuHidden(newValue) {
      if (!newValue) {
        await this.getCategoryStats(this.season);
        await this.getPredefinedfilters(this.category);
      }
    },
  },
  methods: {
    getNationalTeamName(numberTeamId) {
      if (numberTeamId === 392) {
        return 'Selección mexicana';
      }
    },
    getObjectPlayer(arrayPlayerData) {
      const arrayNationalitiesIds = [];
      const arrayNationalities = arrayPlayerData[7].map(objectNationality => {
        arrayNationalitiesIds.push(objectNationality.nationality_id);
        return {
          stringName: objectNationality.nationality,
          numberId: objectNationality.nationality_id,
        };
      });
      return {
        numberId: arrayPlayerData[0],
        stringFullName: arrayPlayerData[1],
        stringImageUrl: arrayPlayerData[2],
        numberTeamId: arrayPlayerData[3],
        stringNationalityName: arrayPlayerData[4],
        numberAge: arrayPlayerData[5],
        numberPositionId: arrayPlayerData[6],
        arrayNationalities,
        arrayNationalitiesIds,
        arrayNationalTeamsAvailable: arrayPlayerData[8],
        dateOfBirth: arrayPlayerData[9],
      };
    },
    changeCarousel(index) {
      this.indexPredefinedFiltersSelected = index;
      this.arrayPredefinedFilters[index].filtersPredefined = JSON.parse(
        JSON.stringify(this.arrayPredefinedOrigin[index].filtersPredefined),
      );
      this.filters(this.arrayPredefinedOrigin[index].filtersPredefined);
      this.numberResetValuesCounter += 1;
    },
    changeItem(value) {
      this.viewImage = value;
    },
    setDinamicFilters(filtersEmit) {
      //SET DYNAMIC VALUES TO DEFAULT FILTERS OF A DESCRIPTION
      this.arrayPredefinedFilters[
        this.indexPredefinedFiltersSelected
      ].filtersPredefined.end_age = filtersEmit.arrayAgeRange ? filtersEmit.arrayAgeRange[1] : 0;
      this.arrayPredefinedFilters[
        this.indexPredefinedFiltersSelected
      ].filtersPredefined.start_age = filtersEmit.arrayAgeRange ? filtersEmit.arrayAgeRange[0] : 0;
      this.arrayPredefinedFilters[
        this.indexPredefinedFiltersSelected
      ].filtersPredefined.nationalities = filtersEmit.setNationalitiesIds ? filtersEmit.setNationalitiesIds : [];
      this.arrayPredefinedFilters[
        this.indexPredefinedFiltersSelected
      ].filtersPredefined.positions = filtersEmit.setPositionsIds ? filtersEmit.setPositionsIds : [];
      this.arrayPredefinedFilters[
        this.indexPredefinedFiltersSelected
      ].filtersPredefined.elegible = filtersEmit.numberNationalTeamSelectedId
        ? filtersEmit.numberNationalTeamSelectedId
        : 0;
      this.arrayPredefinedFilters[
        this.indexPredefinedFiltersSelected
      ].filtersPredefined.elegibleBoolean = filtersEmit.booleanAreNationalTeamsVisible
        ? filtersEmit.booleanAreNationalTeamsVisible
        : false;
    },
    filters(filters) {
      this.objectSelectedFilters = { ...filters };
      if (this.objectSelectedFilters.booleanIsAgeRangeSelected === undefined) {
        this.objectSelectedFilters.booleanIsAgeRangeSelected = true;
      }
      this.filterEmitAux = filters;
      this.getTextFilterPredefinedCustom();
      this.formatFilterStats = this.filterRecords(filters);
      this.filterActive = true;
      this.viewImage = 0;
      this.filterSend = filters;
    },
    getTextFilterPredefinedCustom() {
      this.setDinamicFilters(this.filterEmitAux);
      var filterTextCustom = this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].textOrigin;
      const filterFieldSearch = this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.zone
        .sort((a, b) => a - b)
        .toString();
      if (
        this.predefinedFiltersSections[filterFieldSearch] ||
        this.predefinedFiltersSections[filterFieldSearch] == ''
      ) {
        if (this.predefinedFiltersSections[filterFieldSearch] == '') {
          filterTextCustom = filterTextCustom.replace(
            ' [en {field_sections}]',
            this.predefinedFiltersSections[filterFieldSearch],
          );
        } else {
          filterTextCustom = filterTextCustom.replace(
            '{field_sections}',
            this.predefinedFiltersSections[filterFieldSearch],
          );
        }
      } else {
        filterTextCustom = filterTextCustom.replace('{field_sections}', this.predefinedFiltersSections['other']);
      }
      var flagPosi = false;

      if (!this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.elegibleBoolean) {
        filterTextCustom = filterTextCustom.replace('[elegibles para la selección {eligible}]', '');
        if (this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.nationalities.size > 0) {
          if (
            this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.nationalities.size ==
            this.setNationalityIds.size
          ) {
            filterTextCustom = filterTextCustom.replace('[{nationality}]', '');
            filterTextCustom = filterTextCustom.replace('[de las nacionalidades y posiciones seleccionadas]', '');
            filterTextCustom = filterTextCustom.replace('[de las nacionalidades seleccionadas]', '');
          } else {
            if (
              this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.nationalities.size == 1
            ) {
              filterTextCustom = filterTextCustom.replace(
                '[{nationality}]',
                this.$t(
                  `gentilicios[${
                    [
                      ...this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined
                        .nationalities,
                    ][0]
                  }]`,
                ),
              );
              filterTextCustom = filterTextCustom.replace('[de las nacionalidades y posiciones seleccionadas]', '');
              filterTextCustom = filterTextCustom.replace('[de las nacionalidades seleccionadas]', '');
            } else {
              if (
                this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.positions.size > 1 &&
                this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.positions.size !=
                  this.setPositionsIds.size
              ) {
                flagPosi = true;
                filterTextCustom = filterTextCustom.replace('[{nationality}]', '');
                filterTextCustom = filterTextCustom.replace('[de las nacionalidades seleccionadas]', '');
              } else {
                filterTextCustom = filterTextCustom.replace('[{nationality}]', '');
                filterTextCustom = filterTextCustom.replace('[de las nacionalidades y posiciones seleccionadas]', '');
              }
            }
          }
        } else {
          filterTextCustom = filterTextCustom.replace('[{nationality}]', '');
          filterTextCustom = filterTextCustom.replace('[de las nacionalidades y posiciones seleccionadas]', '');
          filterTextCustom = filterTextCustom.replace('[de las nacionalidades seleccionadas]', '');
        }
      } else {
        filterTextCustom = filterTextCustom.replace('[{nationality}]', '');
        filterTextCustom = filterTextCustom.replace('[de las nacionalidades y posiciones seleccionadas]', '');
        filterTextCustom = filterTextCustom.replace('[de las nacionalidades seleccionadas]', '');
        filterTextCustom = filterTextCustom.replace(
          '[elegibles para la selección {eligible}]',
          '[elegibles para la selección ' +
            this.$t(
              `elegibles[${
                this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.elegible
              }]`,
            ),
          +']',
        );
      }
      if (this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.positions.size > 1) {
        if (flagPosi) {
          filterTextCustom = filterTextCustom.replace('[de las posiciones seleccionadas]', '');
        } else {
          if (
            this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.positions.size ==
            this.setPositionsIds.size
          ) {
            filterTextCustom = filterTextCustom.replace('[de las posiciones seleccionadas]', '');
          }
        }
      } else {
        filterTextCustom = filterTextCustom.replace('[de las posiciones seleccionadas]', '');
      }
      if (this.objectSelectedFilters.booleanIsAgeRangeSelected === true) {
        filterTextCustom = filterTextCustom.replace(' [nacidos durante o después del año {year}]', '');
        if (
          this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.start_age != 0 &&
          this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.end_age != 0
        ) {
          if (
            this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.start_age !=
              this.arrayAgeRange[0] &&
            this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.end_age !=
              this.arrayAgeRange[1]
          ) {
            if (
              this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.start_age ==
              this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.end_age
            ) {
              filterTextCustom = filterTextCustom.replace('[de {min_age} a {max_age} años]', '');
              filterTextCustom = filterTextCustom.replace(
                '[de {min_age} años]',
                '[de ' +
                  this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.start_age +
                  ' años]',
              );
            } else {
              filterTextCustom = filterTextCustom.replace('[de {min_age} años]', '');
              filterTextCustom = filterTextCustom.replace(
                '[de {min_age} a {max_age} años]',
                '[de ' +
                  this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.start_age +
                  ' a ' +
                  this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.end_age +
                  ' años]',
              );
            }
          } else {
            if (
              this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.start_age !=
                this.arrayAgeRange[0] ||
              this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.end_age !=
                this.arrayAgeRange[1]
            ) {
              if (
                this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.start_age ==
                this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.end_age
              ) {
                filterTextCustom = filterTextCustom.replace('[de {min_age} a {max_age} años]', '');
                filterTextCustom = filterTextCustom.replace(
                  '[de {min_age} años]',
                  '[de ' +
                    this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.start_age +
                    ' años]',
                );
              } else {
                filterTextCustom = filterTextCustom.replace('[de {min_age} años]', '');
                filterTextCustom = filterTextCustom.replace(
                  '[de {min_age} a {max_age} años]',
                  '[de ' +
                    this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.start_age +
                    ' a ' +
                    this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.end_age +
                    ' años]',
                );
              }
            } else {
              filterTextCustom = filterTextCustom.replace('[de {min_age} a {max_age} años]', '');
              filterTextCustom = filterTextCustom.replace('[de {min_age} años]', '');
            }
          }
        } else {
          filterTextCustom = filterTextCustom.replace('[de {min_age} años]', '');
          filterTextCustom = filterTextCustom.replace('[de {min_age} a {max_age} años]', '');
        }
      } else {
        filterTextCustom = filterTextCustom.replace('[de {min_age} años]', '');
        filterTextCustom = filterTextCustom.replace('[de {min_age} a {max_age} años]', '');
        if (
          this.objectSelectedFilters.booleanIsAgeRangeSelected === false &&
          this.objectSelectedFilters.numberYearOfBirt
        ) {
          filterTextCustom = filterTextCustom.replace(
            ' [nacidos durante o después del año {year}]',
            ` [nacidos durante o después del año ${this.objectSelectedFilters.numberYearOfBirt}]`,
          );
        } else {
          filterTextCustom = filterTextCustom.replace(' [nacidos durante o después del año {year}]', '');
        }
      }
      const filterMatchSearch = this.arrayPredefinedFilters[
        this.indexPredefinedFiltersSelected
      ].filtersPredefined.sections
        .sort()
        .toString();
      if (
        this.predefinedFiltersMatchLapse[filterMatchSearch] ||
        this.predefinedFiltersMatchLapse[filterMatchSearch] == ''
      ) {
        if (this.predefinedFiltersMatchLapse[filterMatchSearch] == '') {
          filterTextCustom = filterTextCustom.replace(
            ' [durante {match_lapse}]',
            this.predefinedFiltersMatchLapse[filterMatchSearch],
          );
        } else {
          filterTextCustom = filterTextCustom.replace(
            '{match_lapse}',
            this.predefinedFiltersMatchLapse[filterMatchSearch],
          );
        }
      } else {
        filterTextCustom = filterTextCustom.replace('{match_lapse}', ' ' + this.predefinedFiltersMatchLapse['other']);
        var textfilterMatchAlternative = '';
        if (filterMatchSearch.includes(1)) {
          textfilterMatchAlternative = textfilterMatchAlternative + '0-15, ';
        }
        if (filterMatchSearch.includes(2)) {
          textfilterMatchAlternative = textfilterMatchAlternative + '16-30, ';
        }
        if (filterMatchSearch.includes(3)) {
          textfilterMatchAlternative = textfilterMatchAlternative + '31-45, ';
        }
        if (filterMatchSearch.includes(4)) {
          textfilterMatchAlternative = textfilterMatchAlternative + '46-60, ';
        }
        if (filterMatchSearch.includes(5)) {
          textfilterMatchAlternative = textfilterMatchAlternative + '61-75, ';
        }
        if (filterMatchSearch.includes(6)) {
          textfilterMatchAlternative = textfilterMatchAlternative + '76-90, ';
        }
        textfilterMatchAlternative = textfilterMatchAlternative.slice(0, -2);
        textfilterMatchAlternative = textfilterMatchAlternative.replace(/,([^,]*)$/, ' y ' + '$1');
        filterTextCustom = filterTextCustom.replace('{match_lapse_selected}', textfilterMatchAlternative);
      }
      const filterPlayingAsSearch = this.arrayPredefinedFilters[
        this.indexPredefinedFiltersSelected
      ].filtersPredefined.playingAs
        .sort()
        .toString();
      if (
        this.predefinedFiltersPlayingAs[filterPlayingAsSearch] ||
        this.predefinedFiltersPlayingAs[filterPlayingAsSearch] == ''
      ) {
        if (this.predefinedFiltersPlayingAs[filterPlayingAsSearch] == '') {
          filterTextCustom = filterTextCustom.replace(
            ' [jugando como {playing_as}]',
            this.predefinedFiltersPlayingAs[filterPlayingAsSearch],
          );
        } else {
          filterTextCustom = filterTextCustom.replace(
            '{playing_as}',
            this.predefinedFiltersPlayingAs[filterPlayingAsSearch],
          );
        }
      }

      if (this.typeSelected == 1) {
        if (this.getUser.tournament == 1001) {
          if (this.category.id == 22) {
            if (
              this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.positions.size == 1
            ) {
              filterTextCustom = filterTextCustom.replace(
                '{section_type}',
                this.$t(
                  `positions.${
                    [...this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.positions][0]
                  }`,
                ),
              );
            } else {
              filterTextCustom = filterTextCustom.replace('{section_type}', 'Porteras');
            }
          } else {
            if (
              this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.positions.size == 1
            ) {
              filterTextCustom = filterTextCustom.replace(
                '{section_type}',
                this.$t(
                  `positions.${
                    [...this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.positions][0]
                  }`,
                ),
              );
            } else {
              filterTextCustom = filterTextCustom.replace('{section_type}', 'Jugadoras');
            }
          }
        } else {
          if (this.category.id == 22) {
            if (
              this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.positions.size == 1
            ) {
              filterTextCustom = filterTextCustom.replace(
                '{section_type}',
                this.$t(
                  `positions.${
                    [...this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.positions][0]
                  }`,
                ),
              );
            } else {
              filterTextCustom = filterTextCustom.replace('{section_type}', 'Porteros');
            }
          } else {
            if (
              this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.positions.size == 1
            ) {
              filterTextCustom = filterTextCustom.replace(
                '{section_type}',
                this.$t(
                  `positions.${
                    [...this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].filtersPredefined.positions][0]
                  }`,
                ),
              );
            } else {
              filterTextCustom = filterTextCustom.replace('{section_type}', 'Jugadores');
            }
          }
        }
      } else {
        filterTextCustom = filterTextCustom.replace('{section_type}', 'Equipos');
      }
      filterTextCustom = filterTextCustom.replace(/\[/g, '');
      filterTextCustom = filterTextCustom.replace(/\]/g, '');
      filterTextCustom = filterTextCustom.replace(
        '{category_name}',
        this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].category_name,
      );
      const filterNameItem = filterTextCustom.split(': ');
      let textFinal = filterNameItem[1].charAt(0).toUpperCase() + filterNameItem[1].toLowerCase().slice(1);
      let textForDots = filterNameItem[1].charAt(0).toUpperCase() + filterNameItem[1].toLowerCase().slice(1);
      this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].text = textFinal;
      this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].title = filterNameItem[0] + ':';
      const matches = textForDots.match(/\*/g);
      if (matches && matches.length) {
        if (matches.length % 2 === 0) {
          for (let i = 1; i <= matches.length; i++) {
            if (i % 2 === 0) {
              textForDots = textForDots.replace('*', '</span>');
            } else {
              textForDots = textForDots.replace('*', '<span style="color: #ffff03" >');
            }
          }
        } else {
          textForDots = textForDots.replaceAll('*', '');
        }
      }
      var dotshtmladd =
        '<span ' +
        "id='showIDtootip' " +
        "class='dots' " +
        "style='width: 100px; height: 20px; z-index: 6; cursor:pointer;'>" +
        '...</span></span>';
      if (this.windowWidth >= 1220) {
        if (textForDots.length > 139) {
          const logSTR = this.stringValidator(textForDots, 139);
          textForDots = logSTR + dotshtmladd;
        }
      }

      if (this.windowWidth >= 1150 && this.windowWidth < 1220) {
        if (textForDots.length > 130) {
          const logSTR = this.stringValidator(textForDots, 130);
          textForDots = logSTR + dotshtmladd;
        }
      }

      if (this.windowWidth > 1080 && this.windowWidth < 1150) {
        if (textForDots.length > 124) {
          const logSTR = this.stringValidator(textForDots, 124);
          textForDots = logSTR + dotshtmladd;
        }
      }
      if (this.windowWidth > 700 && this.windowWidth < 750) {
        if (textForDots.length > 172) {
          const logSTR = this.stringValidator(textForDots, 172);
          textForDots = logSTR + dotshtmladd;
        }
      }
      if (this.windowWidth > 650 && this.windowWidth <= 700) {
        if (textForDots.length > 159) {
          const logSTR = this.stringValidator(textForDots, 159);
          textForDots = logSTR + dotshtmladd;
        }
      }
      if (this.windowWidth > 600 && this.windowWidth <= 650) {
        if (textForDots.length > 139) {
          const logSTR = this.stringValidator(textForDots, 139);
          textForDots = logSTR + dotshtmladd;
        }
      }
      if (this.windowWidth > 550 && this.windowWidth <= 600) {
        if (textForDots.length > 130) {
          const logSTR = this.stringValidator(textForDots, 130);
          textForDots = logSTR + dotshtmladd;
        }
      }
      if (this.windowWidth > 500 && this.windowWidth <= 550) {
        if (textForDots.length > 118) {
          const logSTR = this.stringValidator(textForDots, 118);
          textForDots = logSTR + dotshtmladd;
        }
      }
      if (this.windowWidth > 390 && this.windowWidth <= 500) {
        if (textForDots.length > 95) {
          const logSTR = this.stringValidator(textForDots, 95);
          textForDots = logSTR + dotshtmladd;
        }
      }
      if (this.windowWidth > 360 && this.windowWidth <= 390) {
        if (textForDots.length > 85) {
          const logSTR = this.stringValidator(textForDots, 85);
          textForDots = logSTR + dotshtmladd;
        }
      }
      if (this.windowWidth > 340 && this.windowWidth <= 360) {
        if (textForDots.length > 100) {
          const logSTR = this.stringValidator(textForDots, 100);
          textForDots = logSTR + dotshtmladd;
        }
      }
      if (this.windowWidth <= 340) {
        if (textForDots.length > 90) {
          const logSTR = this.stringValidator(textForDots, 90);
          textForDots = logSTR + dotshtmladd;
        }
      }

      this.arrayPredefinedFilters[this.indexPredefinedFiltersSelected].titledots = textForDots;
    },
    stringValidator(text, limit) {
      let isInSpam = 0;
      var newText = '';
      let auxText = '';

      for (let count = 0; count < text.length; count++) {
        if (text[count] == '<') {
          isInSpam = 1;
        }

        if (isInSpam == 1) {
          auxText += text[count];

          if (text[count] == '>') {
            isInSpam = 2;
          }
        }

        if (auxText != '' && isInSpam == 2) {
          if (newText.length + auxText.length <= limit) {
            newText += auxText;
            auxText = '';
            isInSpam = 0;
          } else {
            break;
          }
        } else if (isInSpam != 1) {
          let cadena = newText.length + 1;
          if (cadena <= limit) {
            newText += text[count];
          } else {
            break;
          }
        }
      }

      return newText;
    },
    async getPredefinedfilters(category) {
      this.arrayPredefinedFilters = [];
      this.arrayPredefinedOrigin = [];
      const dataCategory = await axios
        .get(this.urlFilter + this.category.id)
        .then(response => response)
        .catch(e => {
          if (this.retries > 0) {
            this.retries = this.retries - 1;
            return this.getPredefinedfilters(category);
          }
          return e;
        });
      Object.keys(dataCategory.data[0].match_lapse_combinations).forEach(key => {
        this.predefinedFiltersMatchLapse[key.toString()] = dataCategory.data[0].match_lapse_combinations[key];
      });
      Object.keys(dataCategory.data[0].playing_as_combinations).forEach(key => {
        this.predefinedFiltersPlayingAs[key.toString()] = dataCategory.data[0].playing_as_combinations[key];
      });
      Object.keys(dataCategory.data[0].field_sections_combinations).forEach(key => {
        this.predefinedFiltersSections[key.toString()] = dataCategory.data[0].field_sections_combinations[key];
      });
      if (dataCategory.data[0]) {
        for (let indexRecord = 0; indexRecord < dataCategory.data[0].filter_records.length; indexRecord++) {
          var filterText = dataCategory.data[0].description;

          if (dataCategory.data[0].filter_records[indexRecord].field_sections !== undefined) {
            const filterFieldSearch = dataCategory.data[0].filter_records[indexRecord].field_sections.toString();
            if (
              this.predefinedFiltersSections[filterFieldSearch] ||
              this.predefinedFiltersSections[filterFieldSearch] == ''
            ) {
              if (this.predefinedFiltersSections[filterFieldSearch] == '') {
                filterText = filterText.replace(
                  ' [en {field_sections}]',
                  this.predefinedFiltersSections[filterFieldSearch],
                );
              } else {
                filterText = filterText.replace('{field_sections}', this.predefinedFiltersSections[filterFieldSearch]);
              }
            }
          }
          if (dataCategory.data[0].filter_records[indexRecord].match_lapse !== undefined) {
            const filterMatchSearch = dataCategory.data[0].filter_records[indexRecord].match_lapse.toString();
            if (
              this.predefinedFiltersMatchLapse[filterMatchSearch] ||
              this.predefinedFiltersMatchLapse[filterMatchSearch] == ''
            ) {
              if (this.predefinedFiltersMatchLapse[filterMatchSearch] == '') {
                filterText = filterText.replace(
                  ' [durante {match_lapse}]',
                  this.predefinedFiltersMatchLapse[filterMatchSearch],
                );
              } else {
                filterText = filterText.replace('{match_lapse}', this.predefinedFiltersMatchLapse[filterMatchSearch]);
              }
            }
          }
          if (dataCategory.data[0].filter_records[indexRecord].playing_as !== undefined) {
            const filterPlayingAsSearch = dataCategory.data[0].filter_records[indexRecord].playing_as.toString();
            if (
              this.predefinedFiltersPlayingAs[filterPlayingAsSearch] ||
              this.predefinedFiltersPlayingAs[filterPlayingAsSearch] == ''
            ) {
              if (this.predefinedFiltersPlayingAs[filterPlayingAsSearch] == '') {
                filterText = filterText.replace(
                  ' [jugando como {playing_as}]',
                  this.predefinedFiltersPlayingAs[filterPlayingAsSearch],
                );
              } else {
                filterText = filterText.replace('{playing_as}', this.predefinedFiltersPlayingAs[filterPlayingAsSearch]);
              }
            }
          }
          if (dataCategory.data[0].filter_records[indexRecord].section_type !== undefined) {
            if (dataCategory.data[0].filter_records[indexRecord].section_type == 1) {
              filterText = filterText.replace('{section_type}', 'Jugadores');
            } else {
              filterText = filterText.replace('{section_type}', 'Equipos');
            }
          }
          filterText = filterText.replace(' [nacidos durante o después del año {year}]', '');

          filterText = filterText.replace(/\[/g, '');
          filterText = filterText.replace(/\]/g, '');
          filterText = filterText.replace('{category_name}', dataCategory.data[0].category_name);
          const filterNameItem = filterText.split(': ');
          var textFinal = filterNameItem[1];
          if (textFinal.length > 129 && this.windowWidth > 1358) {
            textFinal = textFinal.substring(0, 129);
            textFinal =
              textFinal +
              "<span id='showIDtootip' class='dots' style='width: 100px; height: 20px; background: red; z-index: 6;'" +
              '>...</span>';
          }
          if (!this.isCup || dataCategory.data[0].filter_records[indexRecord].playing_as.length === 2) {
            this.arrayPredefinedFilters.push({
              id: indexRecord,
              category_name: this.category.name,
              id_category: dataCategory.data[0].id,
              title: filterNameItem[0] + ':',
              text: filterNameItem[1],
              textOrigin: dataCategory.data[0].description,
              titledots: textFinal,
              filtersPredefined: {
                matchResult: dataCategory.data[0].filter_records[indexRecord].match_result,
                playingAs: dataCategory.data[0].filter_records[indexRecord].playing_as,
                sections: dataCategory.data[0].filter_records[indexRecord].match_lapse,
                type: 1,
                typeZone: dataCategory.data[0].type_zone,
                zone: dataCategory.data[0].filter_records[indexRecord].field_sections,
                end_age: 0,
                start_age: 0,
                nationalities: [],
                elegible: 0,
                elegibleBoolean: false,
                positions: [],
              },
            });
          }
        }
        this.filters(this.arrayPredefinedFilters[0].filtersPredefined);
        this.arrayPredefinedOrigin = JSON.parse(JSON.stringify(this.arrayPredefinedFilters));
      }
    },

    async getCategoryStats(season) {
      this.mapPlayers = new Map();
      try {
        if (!season) return;
        let catPlays = [];
        let teamData = {};
        let playersData = {};
        this.arePlaysEmpty = false;
        var categoryget = '';
        if (this.category.id == 1 || this.category.id == 2) {
          categoryget = this.category.id + '?p=1';
        } else {
          categoryget = this.category.id;
        }

        const data = await axios
          .get(this.url + '/' + season + '/' + categoryget)
          .then(response => response)
          .catch(e => {
            if (this.retries > 0) {
              this.retries = this.retries - 1;
              return this.getCategoryStats(season);
            }
            return e;
          });
        if (data && data.data && data.data.data && data.data.data.length > 0) {
          const mapAvailableNationalTeams = data.data.eligible.reduce((accumulator, objectNationalTeam) => {
            accumulator.set(objectNationalTeam.team_id, {
              setAvailablePlayersIds: new Set(),
              ...objectNationalTeam,
              stringName: this.getNationalTeamName(objectNationalTeam.team_id),
            });
            return accumulator;
          }, new Map());
          catPlays = data.data.data.map(play => {
            return this.formatStatsData(play);
          });
          data.data.teams.forEach(data => {
            teamData[data[0]] = {};
            teamData[data[0]]['id'] = data[0];
            teamData[data[0]]['name'] = data[1];
            teamData[data[0]]['img'] = data[3];
            teamData[data[0]]['abrv'] = data[2];
          });
          const setNationalityIds = new Set();
          const setAvailableYears = new Set();
          data.data.players.forEach(data => {
            const objectPlayer = this.getObjectPlayer(data);
            const yearOfBirth = Number(objectPlayer.dateOfBirth.split('-')[0]);
            objectPlayer.yearOfBirth = yearOfBirth;
            setAvailableYears.add(yearOfBirth);
            data[8].forEach(objectPlayerAvailableNationalTeam => {
              const objectAvailableNationalTeam = mapAvailableNationalTeams.get(
                objectPlayerAvailableNationalTeam.team_id,
              );
              if (objectAvailableNationalTeam) {
                objectAvailableNationalTeam.setAvailablePlayersIds.add(objectPlayer.numberId);
              }
            });
            this.mapPlayers.set(objectPlayer.numberId, objectPlayer);
            const numberPlayerAge = objectPlayer.numberAge;
            objectPlayer.arrayNationalities.forEach(objectNationality => {
              setNationalityIds.add(objectNationality.numberId);
            });

            playersData[data[0]] = {
              id: data[0],
              name: data[1],
              img: data[2],
              age: numberPlayerAge,
              yearOfBirth,
            };
          });

          this.arrayAvailableYears = Array.from(setAvailableYears.values());
          this.arrayAvailableYears.sort((a, b) => b - a);
          this.setNationalityIds = setNationalityIds;
          this.mapAvailableNationalTeams = mapAvailableNationalTeams;
          this.arrayAgeRange = [data.data.min_age, data.data.max_age];
        } else {
          this.arePlaysEmpty = true;
        }
        this.teamInfo = teamData;
        this.playersInfo = playersData;
        this.formatStats = catPlays;
        this.formatFilterStats = this.filterRecords(this.filtersSelect);
        this.statsData = data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    updateSliderF() {
      this.updateSlider += 1;
    },
    filterRecords(filtersEmit) {
      let allFilters = false;
      let statsFilter = [];
      statsFilter = this.formatStats.filter(play => {
        let matchZone = false;
        const playingAs = filtersEmit.playingAs.includes(play.playing_as);
        const matchResult = filtersEmit.matchResult.includes(play.match_result);
        const matchLapse = filtersEmit.sections.includes(play.section);
        if (
          filtersEmit.setPositionsIds &&
          filtersEmit.setNationalitiesIds &&
          filtersEmit.setAvailableNationalTeamsPlayersIds &&
          filtersEmit.arrayAgeRange &&
          !this.isTeam
        ) {
          const objectPlayer = this.mapPlayers.get(play.player_id);
          if (objectPlayer) {
            // position validation
            if (this.setPositionsIds.size !== 1 && filtersEmit.setPositionsIds.size === this.setPositionsIds.size) {
              // if all positions ids are selected, add id 10 for "unknown position"
              filtersEmit.setPositionsIds.add(10);
            }
            if (!filtersEmit.setPositionsIds.has(objectPlayer.numberPositionId)) {
              return false;
            }
            if (filtersEmit.booleanAreNationalTeamsVisible) {
              // national team validation
              if (filtersEmit.setAvailableNationalTeamsPlayersIds.size > 0) {
                if (!filtersEmit.setAvailableNationalTeamsPlayersIds.has(play.player_id)) {
                  return false;
                }
              }
            } else {
              // nationality validation
              let booleanHasNationality = false;
              for (const numberNationalityId of objectPlayer.arrayNationalitiesIds) {
                if (filtersEmit.setNationalitiesIds.has(numberNationalityId)) {
                  booleanHasNationality = true;
                  break;
                }
              }
              if (!booleanHasNationality) {
                return false;
              }
            }

            if (filtersEmit.booleanIsAgeRangeSelected) {
              // age validation
              if (
                objectPlayer.numberAge < filtersEmit.arrayAgeRange[0] ||
                objectPlayer.numberAge > filtersEmit.arrayAgeRange[1]
              ) {
                return false;
              }
            } else if (filtersEmit.numberYearOfBirt && objectPlayer.yearOfBirth < filtersEmit.numberYearOfBirt) {
              return false;
            }
          } else {
            return false;
          }
        }

        if (filtersEmit.typeZone == 1) {
          matchZone = filtersEmit.zone.includes(play.origen);
        }
        if (filtersEmit.typeZone == 2) {
          matchZone = filtersEmit.zone.includes(play.destino);
        }
        if (
          filtersEmit.playingAs.length > 0 ||
          filtersEmit.matchResult.length > 0 ||
          filtersEmit.sections.length > 0 ||
          filtersEmit.zone.length > 0
        ) {
          if (
            filtersEmit.playingAs.length > 0 &&
            filtersEmit.matchResult.length > 0 &&
            filtersEmit.sections.length > 0 &&
            filtersEmit.zone.length > 0
          ) {
            allFilters = playingAs && matchResult && matchLapse && matchZone;
          } else {
            if (
              filtersEmit.playingAs.length > 0 &&
              filtersEmit.matchResult.length > 0 &&
              filtersEmit.sections.length > 0
            ) {
              allFilters = playingAs && matchResult && matchLapse;
            } else {
              if (
                filtersEmit.playingAs.length > 0 &&
                filtersEmit.matchResult.length > 0 &&
                filtersEmit.zone.length > 0
              ) {
                allFilters = playingAs && matchResult && matchZone;
              } else {
                if (
                  filtersEmit.matchResult.length > 0 &&
                  filtersEmit.sections.length > 0 &&
                  filtersEmit.zone.length > 0
                ) {
                  allFilters = matchResult && matchLapse && matchZone;
                } else {
                  if (filtersEmit.playingAs.length > 0 && filtersEmit.zone.length > 0) {
                    allFilters = playingAs && matchZone;
                  } else {
                    if (filtersEmit.playingAs.length > 0 && filtersEmit.sections.length > 0) {
                      allFilters = playingAs && matchLapse;
                    } else {
                      if (filtersEmit.playingAs.length > 0 && filtersEmit.matchResult.length > 0) {
                        allFilters = playingAs && matchResult;
                      } else {
                        if (filtersEmit.zone.length > 0 && filtersEmit.sections.length > 0) {
                          allFilters = matchZone && matchLapse;
                        } else {
                          if (filtersEmit.zone.length > 0 && filtersEmit.matchResult.length > 0) {
                            allFilters = matchZone && matchResult;
                          } else {
                            if (filtersEmit.sections.length > 0 && filtersEmit.matchResult.length > 0) {
                              allFilters = matchLapse && matchResult;
                            } else {
                              allFilters = matchResult || matchLapse || playingAs || matchZone;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        } else {
          allFilters = true;
        }
        this.updateSliderF();
        return allFilters;
      });

      return statsFilter;
    },
    formatArrayPaginate(arrayData) {
      let num = parseInt(arrayData.length / 10);
      let mod = arrayData.length % 10;
      if (mod > 0) {
        num = num + 1;
      }
      var arrayPlayers = [];
      for (let index = 1; index <= num; index++) {
        var items = index * 10;
        arrayPlayers[index - 1] = arrayData.slice(items - 10, items);
      }
      return arrayPlayers;
    },
    formatStatsData(play) {
      let formattedPlay = {};
      if (play[1] == 0 && play[2] == 1) {
        play[2] = 2;
      } else {
        if (play[1] == 0 && play[2] == 2) {
          play[2] = 1;
        }
      }

      if (play[1] == 0 && play[3] == 1) {
        play[3] = 2;
      } else {
        if (play[1] == 0 && play[3] == 2) {
          play[3] = 1;
        }
      }

      this.data_headers.forEach((header, index) => {
        formattedPlay[header] = play[index];
      });
      return formattedPlay;
    },
    show(flag) {
      if (flag) {
        this.openLayer = true;
        setTimeout(() => {
          this.openDrawer = true;
        }, 100);
      } else {
        this.openDrawer = false;
        setTimeout(() => {
          this.openLayer = false;
        }, 500);
      }
    },
    showDrawer() {
      this.openLayer = true;
      setTimeout(() => {
        this.openDrawer = true;
      }, 100);
    },
    hideDrawer() {
      this.openDrawer = false;
      setTimeout(() => {
        this.openLayer = false;
      }, 500);
    },
    setUpIntersectionObserver() {
      if (!window.IntersectionObserver) {
        this.isMenuHidden = false;
        return;
      }
      const observer = new IntersectionObserver(entries => {
        this.intersectionObserverCounter++;
        if (entries[0].intersectionRatio > 0 || this.intersectionObserverCounter === 2) {
          observer.unobserve(this.$refs.skeletonBlock.$el);
          if (this.season) {
            this.isMenuHidden = false;
          } else {
            this.isVisible = true;
          }
        }
      });
      observer.observe(this.$refs.skeletonBlock.$el);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setUpIntersectionObserver();
    });
  },
};
</script>
<style lang="scss" scoped>
.text-bold-overlay {
  font-size: 27px;
  @media screen and (max-width: 480px) {
    font-size: 24px;
  }
}
.subtext-bold-overlay {
  font-size: 19px;
  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
}
.container-menu-top-all {
  //overflow: hidden;
  min-height: 533px;
}
.div-centyer-text {
  width: 100%;
  margin-top: 44%;
  display: table-cell;
  vertical-align: middle;
  margin: 0 auto;
  position: relative;
}
$blur: 10px;
.blurred {
  filter: blur($blur);
  -webkit-filter: blur($blur);
  background-color: rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 0;
}
.table-overlay-container {
  position: absolute;
  width: 100%;
  z-index: 1;
  height: 450px;
  overflow: visible;
  position: absolute;
  @media screen and (max-width: 610px) {
    height: 430px;
  }
}
@mixin table-overlay {
  width: 94%;
  height: 94%;
  margin: 0 auto;
  margin-top: 10px;
  font-family: 'Circular-Std-Medium';
  border: dotted 2px #5c5c5c;
  color: #3e3e3e;
  border-radius: 8px;
  display: table;
  text-align: center;
  position: relative;
}

@mixin font-circular-bold {
  font-family: 'Circular-Std-Black';
  color: #272727f5;
}

.table-overlay {
  &--mobile {
    @include table-overlay;
    // font-size: clamp(0.5rem, 1.5rem, 3vw);
    & > b {
      @include font-circular-bold;
    }
  }
  &--desktop {
    @include table-overlay;
    @media screen and (min-width: 1280px) {
      // font-size: clamp(0.5rem, 1.5rem, 1.5vw);
      & > b {
        @include font-circular-bold;
      }
    }
  }

  &--mobile,
  &--desktop {
    transition: width 50ms;
    transition-timing-function: linear;
  }
}
.border-detail-top {
  border-bottom: 2px solid #88da69;
}
.border-detail-bottom {
  @media screen and (max-width: 610px) {
    border-top: 2px solid #88da69;
  }
}
.container-not-found-data {
  width: 100%;
  border-radius: 5px;
  height: 414px;
  border: 2px dashed #dadada;
  display: inline-block;
  &__img-search {
    width: 100%;
    margin-top: 90px;
  }
  &__title-info {
    width: 100%;
    margin-top: 14px;
    text-align: center;
    font-family: 'Circular-Std';
    font-size: 19px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.52px;
  }
  &__subtitle-info {
    width: 100%;
    text-align: center;
    margin-top: 4px;
    font-family: 'Avenir-Roman';
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.12px;
    color: #9a9a9a;
  }
}
.close-button {
  cursor: pointer;
  position: absolute;
  font-size: 24px;
  letter-spacing: -0.04px;
  text-align: center;
  background-color: #494a4b;
  color: #fff;
  justify-content: space-between;
  align-items: center;
  width: 1.6em;
  padding-top: 8px;
  display: none;
  margin-left: 23px;
  margin-top: 5px;
  border-radius: 4px;
}
.color-gray {
  background-color: #3b3b3b !important;
}
.menu-top {
  width: 100%;
  //margin: 0px !important;
  display: inline-block;
  position: relative;
  border-radius: 2px;
  border: solid 1.1px #c0c0c0;
  height: fit-content;
  &__header {
    border-radius: 2px;
    background-color: #242424;
    padding: 7px 0px 0px 0px;
    position: relative;
    display: flex;
    align-items: center;
    height: 34px;
    @media screen and (max-width: 610px) {
      flex-flow: column;
      height: unset;
    }
  }
  &__header-pc {
    background-color: #242424;
    padding: 7px 0px;
    position: relative;
    display: flex;
    align-items: center;
    height: 40px;
  }
  &__body {
    display: grid;
    // background: pink;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 9px;
    padding: 0px 9px 9px 9px;

    @media screen and (max-width: 610px) {
      grid-template-columns: 1fr;
      padding: 0px 0px 12px 0px;
    }
  }
  &__drawer {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 10px;
    justify-content: flex-end;
    display: none;
    height: 425px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    margin: 262px 0px;
    padding: 0px;
    @media screen and (max-width: 61610px) {
      height: 502px;
    }
    @media screen and (max-width: 370px) {
      margin: 259px 0px;
    }

    &.active {
      @media screen and (max-width: 610px) {
        display: flex;
      }
    }
    .filter-drawer {
      background-color: white;
      width: 0;
      transition: all 0.5s ease-in-out;
      opacity: 0;
      position: relative;
      &.active {
        width: 100%;
        opacity: 1;
        height: 502px;
      }

      .close-btn {
        position: absolute;
        top: 10px;
        left: 21px;
        width: 25px;
        height: 25px;
        color: white;
        display: flex;
        justify-content: center;
        border-radius: 4px;
        background-color: #3b3b3b;
        align-items: center;
        font-size: 21px;
        cursor: pointer;
        line-height: 19px;
        outline: none;
        border: none;
      }
    }
  }
  &__footer {
    border-radius: 2px;
    min-height: 40px;
    box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.07);
    background-color: #fbfbfb;
    display: flex;
    justify-content: center;
    align-items: center;
    .spacer {
      width: 1px;
      height: 0.75rem;
      background-color: #979797;
      margin: 0 16px;
    }
  }
}
.top-header-pc {
  .logo-img {
    position: absolute;
    left: 11px;
    width: 28px;
  }
  &__left-items {
    margin-right: auto;
  }
  &__title {
    font-family: 'Circular-Std-Medium';
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.52px;
    text-align: center;
    color: #ffffff;
    padding-left: 0px;
    position: absolute;
    right: 0;
    left: 0;
    @media screen and (max-width: 560px) {
      font-size: 18px;
    }
  }

  &__right-items {
    font-family: 'Circular-Std-Medium';
    font-size: 11px;
    font-weight: 500;
    display: inline-block;
    text-align: center;
    padding-top: 1px;
    color: #ffffff;

    span {
      padding-right: 10px;
      font-size: 12px;
      color: white;
      opacity: 0.7;

      &.active {
        opacity: 1;
        font-weight: bold;
      }
    }
  }
  @media screen and (max-width: 610px) {
    display: none;
  }
}
.top-header {
  display: none;
  .logo-img {
    position: absolute;
    left: 15px;
    width: 18px;
    @media screen and (max-width: 610px) {
      top: 3px;
    }
  }
  &__left-items {
    margin-right: auto;
  }
  &__adv-btn {
    display: none;
    @media screen and (max-width: 610px) {
      outline: none;
      border: none;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 220px;
      height: 25px;
      margin: 12px 0px;
      border-radius: 7px;
      background-color: #6abe0f;
      font-family: 'Circular-Std-Medium';
      font-size: 12px;
      text-align: center;
      color: #ffffff;
      cursor: pointer;
    }
    img {
      margin-left: 5px;
      width: 12px;
    }
  }
  &__title {
    font-family: 'Circular-Std-Medium';
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.52px;
    text-align: center;
    color: #ffffff;
    padding-left: 10px;
    position: absolute;
    right: 0;
    left: 0;

    @media screen and (max-width: 610px) {
      position: initial;
    }
    @media screen and (max-width: 370px) {
      font-size: 12px;
      height: 16px;
    }
  }
  &__right-items {
    font-family: 'Circular-Std-Medium';
    font-size: 11px;
    font-weight: 500;
    width: 100%;
    height: 30px;
    background: #3b4044;
    padding-top: 5px;
    text-align: center;
    padding-top: 1px;
    color: #ffffff;

    span {
      padding-right: 10px;
    }

    &__background-cont {
      font-family: 'Circular-Std-Medium';
      font-size: 11px;
      font-weight: 500;
      text-align: center;
      display: inline-block;
      padding-top: 5px;
      color: #ffffff;
      margin: 0 auto;
    }
  }
  @media screen and (max-width: 610px) {
    display: flex;
    background-color: blue;
  }
}
.top-body {
  min-height: 452px;
  &__table {
    // background: brown;
  }
  &__filters {
    padding: 4px 0px;
    width: 100%;
    display: flex;
    // background: red;

    @media screen and (max-width: 610px) {
      display: none;
    }
  }
}
.placeholder-item:nth-of-type(odd) {
  background-color: #f5f5f5;
  box-shadow: 0 1px 2px 0 rgba(33, 33, 33, 0.05);
}
.placeholder-item {
  height: 32px;
  position: relative;
  overflow: hidden;
}
.placeholder-item:nth-of-type(odd)::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(to right, transparent 0%, #e8e8e8 50%, transparent 100%);
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@keyframes load {
  from {
    left: -150px;
  }
  to {
    left: 100%;
  }
}
.top-ptable {
  width: 100%;
  margin-bottom: 10px;
  &__header {
    display: grid;
    grid-template-columns: minmax(25px, 30px) 1fr minmax(40px, 60px);
    border-radius: 2.4px;
    text-align: center;
    align-items: center;
  }
  &__header {
    background-color: #dbefca;
    height: 24px;
    span {
      font-family: 'Avenir-Bold';
      font-size: 12px;
      font-weight: bold;
      letter-spacing: -0.18px;
      text-align: center;
      color: #353535;
    }
  }
}
.container-filter-switch {
  span {
    padding-right: 10px;
    font-size: 12px;
    color: white;
    opacity: 0.7;

    &.active {
      opacity: 1;
      font-weight: bold;
    }
  }
}
</style>
<style lang="scss">
$green: #cbee6b;
.menu-top {
  .switch input[type='checkbox'] + .check.is-success-passive,
  .switch input[type='checkbox'] + .check:hover {
    background: $green !important;
    border-color: $green !important;
  }
  .b-radio.radio input[type='radio']:checked + .check.is-success {
    border-color: $green !important;
    background: $green !important;
  }
  .switch:hover input[type='checkbox']:checked + .check.is-success {
    border-color: $green !important;
    background: $green !important;
  }
  .b-radio.radio input[type='radio'] + .check.is-success:before {
    background: $green !important;
  }
  .checkbox input[type='checkbox']:checked + .check.is-success {
    border-color: $green !important;
    background: $green
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:white' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E")
      no-repeat center center !important;
  }
  .top-body__table .carousel .carousel-indicator {
    margin-top: 1em;
  }
  .top-body__table .carousel .carousel-indicator .indicator-item .indicator-style {
    background-color: #e0e0e0;
    border: none;
  }
  .top-body__table .carousel .carousel-indicator .indicator-item.is-active .indicator-style,
  .carousel .carousel-indicator .indicator-item .indicator-style:hover {
    background: $green;
  }
}
</style>
